// @flow
import { decorate, observable, action } from 'mobx';
import { createTransformer } from 'mobx-utils'
import Ployglot from 'node-polyglot';
import Api from '../../api';
import { defaultLanguageCode, getLanguagePack } from '../../lang';
import { merge } from 'lodash';
import { useLocalLanguage, isLocal } from '../../config';
import pathwayStore from '../pathway/PathwayStore';

const defaultLanguagePack = getLanguagePack(defaultLanguageCode);

const getMergedLanguagePack = (languageCode) => {
  const languagePack = getLanguagePack(languageCode);
  const merged = {};
  merge(merged, defaultLanguagePack, languagePack);

  return merged;
};

const getPolygotInstance = (languageCode: string) => {
  const languagePack = languageCode === defaultLanguageCode ?
    defaultLanguagePack :
    getMergedLanguagePack(languageCode);
  const polyglot = new Ployglot({
    locale: languageCode,
    phrases: languagePack
  });

  return polyglot;
};

class LanguageStore {
  lang: any;
  isFetchingLang: boolean = true;
  supportedLanguages: Array<Object>;

  async fetchSupportedLanguages() {
    if (!this.supportedLanguages) {
      this.isFetchingLang = true;
      const { data } = await Api.getLanguagesMeta();
      this.supportedLanguages = data;
      this.isFetchingLang = false;
    }
  }

  isSupported(languageCode: string) {
    if (!languageCode || !this.supportedLanguages) {
      return false;
    }

    const supported = this.supportedLanguages.find(l => l.code === languageCode);
    return !!supported;
  }

  isSupportedLanguage = createTransformer(languageCode => {
    return this.isSupported(languageCode)
  });

  async setLanguage(languageCode: string) {
    await this.fetchSupportedLanguages();
    const code = this.isSupported(languageCode) ? languageCode : defaultLanguageCode;
    if (isLocal && useLocalLanguage) {
      this.lang = getPolygotInstance(code);
    } else {
      this.isFetchingLang = true;
      const { data } = await Api.getLanguage(code);
      this.lang = new Ployglot({
        locale: languageCode,
        phrases: data.phrases
      });
      this.isFetchingLang = false;
    }
    pathwayStore.getPathways(true);
    pathwayStore.getCoachingPathways(true);
  }
}

decorate(LanguageStore, {
  isFetchingLang: observable,
  lang: observable,
  supportedLanguages: observable,
  fetchSupportedLanguages: action,
  setLanguage: action
});

export default new LanguageStore();



// WEBPACK FOOTER //
// ./src/modules/lang/LanguageStore.js